"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CryptoServiceNode_1 = __importDefault(require("./CryptoServiceNode"));
const CryptoServiceWeb_1 = __importDefault(require("./CryptoServiceWeb"));
const service = typeof crypto !== "undefined" && crypto.subtle
    ? new CryptoServiceWeb_1.default()
    : new CryptoServiceNode_1.default();
exports.default = service;
